import { REQUEST, FAILURE, REQUEST_ERRORS, CLEAR_ERRORS, CLEAR_REQUEST_ERRORS, SET_ERRORS } from '../../types';
import { parseError } from './parseError';
// initial State
const state = {
    server: [],
    connection: [],
    validation: []
};
// mutations
const mutations = {
    [REQUEST](state) {
        state.server = [];
        state.connection = [];
        state.validation = [];
    },
    [FAILURE](state, error) {
        if (error instanceof Error) {
            throw error;
        }
        let errors = parseError(error);
        state.connection = errors.connection;
        state.server = errors.server;
        state.validation = errors.validation;
    },
    [REQUEST_ERRORS](state) {
        state.server = [];
        state.validation = [];
    }
};
const actions = {
    /**
     * Clear all errors.
     */
    [CLEAR_ERRORS]({ commit }) {
        commit(REQUEST);
    },
    /**
     * Clear all errors related to requests.
     */
    [CLEAR_REQUEST_ERRORS]({ commit }) {
        commit(REQUEST_ERRORS);
    },
    /**
     * Set errors
     */
    [SET_ERRORS]({ commit }, { errors }) {
        commit(FAILURE, errors);
    }
};
const getters = {
    serverErrors: (state) => state.server,
    validationErrors: (state) => state.validation,
    hasRequestErrors: (state) => Boolean(state.server.length || state.validation.length),
    hasConnectionErrors: (state) => state.connection.length !== 0,
};
export default {
    state,
    mutations,
    actions,
    getters
};
